import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
import Vue from "vue";
import axios from "axios";
import {
    bio_hazard_level_resource, logout_resource,
    project_resource, quantity_type_resource,
    researcher_resource, role_resource,
    sample_resource, study_block_resource,
    theme_resource, user_resource
} from "./api_paths";
import EventBus from "../components/EventBus";
import {APPROVED_STATUS, DECLINED_STATUS} from "@/utils/constants";
import {sample_type_resource} from "@/utils/api_paths";

self.flashMessage = undefined;


export const SYS_ADMIN = "-1"
export const THEME_ADMIN = "1"
export const RESEARCHER = "2"
export const LAB_ADMIN = "3"
export const STUDENT = "4"

export function showFlashMessage(self, status, title, message) {
    self.flashMessage.show({
        icon: "<%= BASE_URL %>/assets/icipe-logo-web-200px-jpg.jpg",
        status: status,
        title: title, message: message
    });
}

export function redirectAfterCountDown(self, route, countDown = 5) {
    if (countDown > 0) {
        setTimeout(() => {
            countDown -= 1;
            redirectAfterCountDown(self, route, countDown);
        }, 1000)
        return countDown
    } else if (countDown === 0) {

        // eslint-disable-next-line no-unused-vars
        self.$router.push({path: route}).then(r => { return r});
    }
    return countDown;
}

/*
* Combined responses for status codes */
export function respondTo401(self) {
    showFlashMessage(self, 'error', "Session Expired", "You need to log in to perform this operation")
    secureStoreDeleteUserInfo()
    redirectAfterCountDown(self, '/login')
}

/*
* Form Util Functions */
export function viewPassword() {
    let passwordInput = document.getElementById('password');
    let pwdEyeIcon = document.getElementById('view-pwd');

    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        pwdEyeIcon.className = 'fa fa-eye-slash';
    } else {
        passwordInput.type = 'password';
        pwdEyeIcon.className = 'fa fa-eye';
    }
}

// DropDownList Functions
// eslint-disable-next-line no-unused-vars
export function getItemDataList(resource, params=null) {
    return axios.get(resource, {
            params : params,
            headers:
                {
                  Authorization: secureStoreGetAuthString()
                }
        })
        .then((res) => {
            // return a promise to be evaluated ...
            return res.data.message
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.log(error);
        });
}

export function extractApiData(data) {
    let itemList = [];
    let fields = {text: '', value: ''};
    let resultObject = {items: itemList, fields: fields};

    for (let item = 0; item < data.length; item++) {
        itemList.push({
            'Code': data[item].code,
            'Name': data[item].name
        });
        fields.text = 'Name';
        fields.value = 'Code';
    }
    return resultObject;
}


export function extractProjectData(data) {
    let itemList = [];
    let fields = {text: '', value: ''};
    let resultObject = {items: itemList, fields: fields};

    for (let item = 0; item < data.length; item++) {
        itemList.push({
            'Code': data[item].code,
            'Name': data[item].name + " headed by " + data[item]['lead.first_name'] + " " + data[item]['lead.last_name']
        });
        fields.text = 'Name';
        fields.value = 'Code';
    }
    return resultObject;
}

export function extractQTData(data) {
    let itemList = [];
    let fields = {text: '', value: ''};
    let resultObject = {items: itemList, fields: fields};

    for (let item = 0; item < data.length; item++) {
        itemList.push({
            'Code': data[item].id,
            'Name': data[item].name
        });
        fields.text = 'Name';
        fields.value = 'Code';
    }
    return resultObject;
}

export function extractUserData(data) {
    let itemList = [];
    let fields = {text: '', value: ''};
    let resultObject = {items: itemList, fields: fields};

    for (let item = 0; item < data.length; item++) {
        itemList.push({
            'Code': data[item].email,
            'Name': data[item].first_name + " " + data[item].last_name
        });
        fields.text = 'Name';
        fields.value = 'Code';
    }
    return resultObject;
}

export function extractBoxData(data) {
    let itemList = [];
    let fields = {text: '', value: ''};
    let resultObject = {items: itemList, fields: fields};

    for (let item = 0; item < data.length; item++) {
        itemList.push({
            'Code': data[item].code,
            'Name': data[item].label,
            'Tray': data[item]['tray.number'],
            'Rack': data[item]['tray.rack.number'],
            'Chamber': data[item]['tray.rack.chamber.type'],
            'Slots': data[item].slots
            // 'Freezer': data[item]['tray.rack.chamber.freezer.number'],
            // 'Lab': data[item]['tray.rack.chamber.freezer.lab.name'] + " room " + data[item]['tray.rack.chamber.freezer.lab.room'],
        });
        fields.text = 'Name';
        fields.value = 'Code';
    }
    return resultObject;
}

export function extractLabData(data) {
    let labList = [];
    let fields = {text: '', value: ''};
    let resultObject = {items: labList, fields: fields};

    for (let item = 0; item < data.length; item++) {
        labList.push({
            'Code': data[item].code,
            'Name': data[item].building,
        });
        fields.text = 'Name';
        fields.value = 'Code';
    }
    return resultObject;
}

export function extractFreezerData(data) {
    let itemList = [];
    let fields = {text: '', value: ''};
    let resultObject = {items: itemList, fields: fields};

    for (let item = 0; item < data.length; item++) {
        itemList.push({
            'Code': data[item].code,
            'Name': "Freezer number(" + data[item].number + ") in " + data[item]['lab.building'] + " room "
                + data[item]['lab.room']
        });
        fields.text = 'Name';
        fields.value = 'Code';
    }
    return resultObject;
}

export function extractChamberData(data) {
    let itemList = [];
    let fields = {text: '', value: ''};
    let resultObject = {items: itemList, fields: fields};

    for (let item = 0; item < data.length; item++) {
        itemList.push({
            'Code': data[item].code,
            'Name': data[item].type
        });
        fields.text = 'Name';
        fields.value = 'Code';
    }
    return resultObject;
}

export function extractRackData(data) {
    let itemList = [];
    let fields = {text: '', value: ''};
    let resultObject = {items: itemList, fields: fields};

    for (let item = 0; item < data.length; item++) {
        itemList.push({
            'Code': data[item].code,
            'Name': "Rack number(" + data[item].number + ") in chamber " + data[item]['chamber.type']
        });
        fields.text = 'Name';
        fields.value = 'Code';
    }
    return resultObject;
}

export function extractTrayData(data) {
    let itemList = [];
    let fields = {text: '', value: ''};
    let resultObject = {items: itemList, fields: fields};

    for (let item = 0; item < data.length; item++) {
        itemList.push({
            'Code': data[item].code,
            'Name': "Tray number(" + data[item].number + ") in rack number " + data[item]['rack.number']
        });
        fields.text = 'Name';
        fields.value = 'Code';
    }
    return resultObject;
}

export function extractApiDataForPub(data) {
    let itemList = [];
    let fields = {text: '', value: ''};
    let resultObject = {items: itemList, fields: fields};

    for (let item = 0; item < data.length; item++) {
        itemList.push({
            'sampleCode': data[item].code,
            'sampleName': "Sample under theme: " + data[item]['theme.name'] + " by " + data[item]['user.first_name'],
            'authorCode': data[item]['user.email'],
            'authorName': data[item]['user.first_name'] + " " + data[item]['user.last_name']
        });
        fields.text = 'Name';
        fields.value = 'Code';
    }
    return resultObject;
}

// eslint-disable-next-line no-unused-vars
export function getSelectedItem(itemDataList, itemVar) {
    let item = document.getElementById("dropdownlist").value;

    for (let i = 0; i < itemDataList.length; i++) {
        if (item === itemDataList[i].Name) {
            itemVar = itemDataList[i].Code;
            return itemVar
        }
    }
}

// todo: ideal fn
export function getSelectedItemCode(elementId, itemDataList) {
    let item = document.getElementById(elementId);

    if (item !== null){
        let value = item.value

        for (let i = 0; i < itemDataList.length; i++) {
            let index_value = parseInt(itemDataList[i].Name)

            if (parseInt(value) === index_value){
                return itemDataList[i].Code
            } else if (value === itemDataList[i].Name) {
                return itemDataList[i].Code
            }
        }
    }
}

// HashMap Implementation
export class HashMap {
    /** NB: Having multiple values in a bucket doesn't improve search in the HashMap since searches take O(n) instead of
     O(1). Therefore, alternative 1 is to have the initial capacity to be length of the array to be store. Having a bigger
     bucket size is excellent to avoid collisions, but it consumes too much memory, and probably most of the buckets
     will be unused. Alternative 2, which is more efficient, is to have a HashMap that automatically increases
     its size as needed i.e. **rehashing**. As such we won’t have collisions; thus, the search time would be O(1) */

    constructor(initialCapacity = 20, loadFactor=.9) {
        this.buckets = new Array(initialCapacity);
        this.loadFactor = loadFactor;
        this.size = 0;
        this.collisions = 0;
        this.keys = [];
    }

    hash(key) {
      let hashValue = 0;
      const stringKey = `${key}${typeof key}`;

      for (let index = 0; index < stringKey.length; index++) {
        const charCode = stringKey.charCodeAt(index);
        hashValue += charCode << (index * 8);
      }
      return hashValue;
    }

    _getBucketIndex(key) {
        const hashValue = this.hash(key);
        return hashValue % this.buckets.length;
    }

    set(key, value) {
        const {bucketIndex, entryIndex} = this._getIndexes(key);

        if(entryIndex === undefined) {
          // initialize array and save key/value
          const keyIndex = this.keys.push({content: key}) - 1; // keep track of the key index
          this.buckets[bucketIndex] = this.buckets[bucketIndex] || [];
          this.buckets[bucketIndex].push({key, value, keyIndex});
          this.size++;
          // Optional: keep count of collisions
          if(this.buckets[bucketIndex].length > 1) { this.collisions++; }
        } else {
          // override existing value
          this.buckets[bucketIndex][entryIndex].value = value;
        }

        // check if a rehash is due and if so, double the size of the bucket
        if(this.loadFactor > 0 && this.getLoadFactor() > this.loadFactor) {
          this.rehash(this.buckets.length * 2);
        }

        return this;
    }

    get(key) {
        const {bucketIndex, entryIndex} = this._getIndexes(key);

        if(entryIndex === undefined) {
          return;
        }

        return this.buckets[bucketIndex][entryIndex].value;
    }

    has(key) {
        return !!this.get(key);
    }

    _getIndexes(key) {
        const bucketIndex = this._getBucketIndex(key);
        const values = this.buckets[bucketIndex] || [];

        for (let entryIndex = 0; entryIndex < values.length; entryIndex++) {
          const entry = values[entryIndex];
          if(entry.key === key) {
            return {bucketIndex, entryIndex};
          }
        }

        return {bucketIndex};
    }

    delete(key) {
        const {bucketIndex, entryIndex, keyIndex} = this._getIndexes(key);

        if(entryIndex === undefined) {
          return false;
        }

        this.buckets[bucketIndex].splice(entryIndex, 1);
        delete this.keys[keyIndex];
        this.size--;

        return true;
    }

    rehash(newCapacity) {
        const newMap = new HashMap(newCapacity);

        this.keys.forEach(key => {
          if(key) {
            newMap.set(key.content, this.get(key.content));
          }
        });

        // update bucket
        this.buckets = newMap.buckets;
        this.collisions = newMap.collisions;
        // Optional: both `keys` has the same content except that the new one doesn't have empty spaces from deletions
        this.keys = newMap.keys;
    }

    getLoadFactor() {
        return this.size / this.buckets.length;
    }
}

export function getSelectedItemSetTextFieldValue(itemDataList, itemVar) {
    let element = document.getElementById("dropdownlist");
    let item

    if (element !== null) {
        item = element.value
    }

    for (let i = 0; i < itemDataList.length; i++) {
        if (item === itemDataList[i].Name) {
            itemVar = itemDataList[i].Code;
            let textValue = itemDataList[i].authorName;
            let textCode = itemDataList[i].authorCode
            return {'sampleCode': itemVar, 'authorText': textValue, 'authorCode': textCode}
        }
    }
}

export function selectItemForUpdate(item) {
    // set dropdownItem to the selected item
    let element = document.getElementById("dropdownlist");
    element.value = item;
}

/** Vuex store for storage for jwt tokens and functions for managing user state */
// todo: redesign secure store.

const ls = new SecureLS({isCompression: false});

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        jwtString: "",
        user: {
            email: "",
            firstName: "",
            lastName: "",
            role: "",
            email_confirmed: false,
        },
    },
    plugins: [
        createPersistedState({
            storage: {
                getItem: key => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: key => ls.remove(key)
            }
        })
    ],
    mutations: {
        jwtToken: (state, value) =>
            value ? (state.jwtString = value) : (state.jwtString = ""),

        userInfo: (state, payload) => {
            return payload ?
                (
                    state.user = {
                        email: payload.email,
                        firstName: payload.firstName,
                        lastName: payload.lastName,
                        role: payload.role,
                        email_confirmed: payload.email_confirmed,
                    }
                )
                :
                (
                    state.user = {
                        email: "",
                        firstName: "",
                        lastName: "",
                        role: "",
                        email_confirmed: false
                    }
                )
        },
    }
});

/*
* User Authentication and Identification functions */
export function secureStoreGetAuthString() {
    let jwtString = store.state.jwtString;

    if (jwtString != null) {
        return 'Bearer ' + jwtString;
    } else {
        // ensures server returns 401 rather than 422
        return ""
    }
}

export function secureStoreSetUserInfo(jwtString, email, fName, lName, role, email_confirmed) {
    store.commit("jwtToken", jwtString);
    store.commit('userInfo', {
        email: email,
        firstName: fName,
        lastName: lName,
        role: role,
        email_confirmed: email_confirmed
    });
}

export function secureStoreDeleteUserInfo() {
    store.commit("jwtToken", null);
    store.commit('userInfo', null);
}

export function getUserEmail() {
    return store.state.user.email
}

export function getStoredUserDetails() {
    let user = {
        'first_name': null,
        'last_name': null,
        'role': null,
        'email_confirmed': false,
    }

    user.first_name = store.state.user.firstName
    user.last_name = store.state.user.lastName
    user.role = store.state.user.role
    user.email_confirmed = store.state.user.email_confirmed
    return user
}

export function strongPassword(password1) {
    return (
        /[a-z]/.test(password1) && //checks for a-z
        /[0-9]/.test(password1) && //checks for 0-9
        /\W|_/.test(password1) && //checks for special char
        password1.length >= 6
    );
}

// user status
export function isUserLoggedIn() {
    return store.state.jwtString !== "";
}

export function getLoggedInUser() {
    let loggedIn = isUserLoggedIn()
    if (loggedIn === true) {
        return getStoredUserDetails()
    }
}

export function logOutUser(self) {
    let loader = startLoader(self)
    axios.get(logout_resource, {
        headers:
            {
                Authorization: secureStoreGetAuthString()
            }
    })
        .then((response) => {
            // redirect after successful signUp
            if (response.status === 200) {
                setTimeout(() => {
                    secureStoreDeleteUserInfo()
                    loader.hide()
                    showFlashMessage(self, 'success', 'Logged Out', 'Redirecting you to home page ' +
                        redirectAfterCountDown(self, '/home') + " seconds");
                }, 2500)
            }
        })
        .catch((error) => {
            loader.hide()
            if (error.response) {
                showFlashMessage(self, 'error', error.response.data['message'], '');
            }
        })
}

/** User roles functions */
// SYSTEM ADMIN FUNCTIONS
export function isAdmin() {
    let userStatus = getLoggedInUser()
    return !!(userStatus && userStatus.role === SYS_ADMIN);
}

// THEME ADMIN FUNCTIONS
export function isThemeAdmin() {
    let userStatus = getLoggedInUser()
    return !!(userStatus && (userStatus.role === THEME_ADMIN));
}

// Researcher Functions
export function isResearcher() {
    let userStatus = getLoggedInUser()
    return !!(userStatus && (userStatus.role === RESEARCHER));
}

// Lab Admin Functions
export function isLabAdmin() {
    let userStatus = getLoggedInUser()
    return !!(userStatus && (userStatus.role === LAB_ADMIN));
}

// Student Functions
export function isStudent() {
    let userStatus = getLoggedInUser()
    return !!(userStatus && (userStatus.role === STUDENT));
}

/** user-resource owner-- functions check if a certain resource belongs to the user whose email has been passed.
 * The resources has association with the user object as such a reference to the user is in the resource data, thus we
 * can determine whether or not the specific resource belongs to the currently logged in user. */
// PUBLICATION OWNER FUNCTIONS
export function isResourceOwner(email) {
    let userEmail = getUserEmail()

    return !!(userEmail && userEmail === email);
}

// SAMPLE OWNER FUNCTIONS
export function isSampleOwner(email) {
    let userEmail = getUserEmail()

    return !!(userEmail && (userEmail === email || isLabAdmin() || isAdmin()));
}

/** Functions for sample managements i.e. AddSample, UpdateSample, DetailedSampleView. The functions here also include
 * techniques of checking for date validity and thus determining the type of view and functionality a sample should have*/
// accessor for sample code; used when requesting to view detailed sample page
let sampleCode = ""
let sample = []
let updateSample = false;

export function setSampleCode(code) {
    sampleCode = code
}

export function getSampleCode() {
    return sampleCode
}

export function setSampleDetailsForEditing(sampleRes) {
    sample = sampleRes
}

export function getSampleDetailsForEditing() {
    return sample;
}

export function setUpdateSample(updateVal) {
    updateSample = updateVal;
}

export function isUpdate() {
    return updateSample;
}

export function viewSample(self, code, delay=1) {
    // 1st call the setter function to set the code
    setSampleCode(code)
    // redirect to sample view page
    redirectAfterCountDown(self, '/view-sample', delay)
}

let fields = null;
let sampleDataList = []
let payload = {}

export function setSampleDataList() {
    getItemDataList(sample_resource).then(data => {
        let sampleList = extractApiDataForPub(data);

        // update local variables with data from API
        fields = sampleList['fields'];
        for (let i = 0; i < sampleList.items.length; i++) {
            sampleDataList.push({
                'Code': sampleList.items[i].sampleCode,
                'Name': sampleList.items[i].sampleName,
                'authorCode': sampleList.items[i].authorCode,
                'authorName': sampleList.items[i].authorName
            });
        }
        payload.fields = fields
        payload.sampleData = sampleDataList
        EventBus.$emit('sample-data-list', payload)
    })
}
let samplesList = []

EventBus.$on('sample-data-to-cart', payload=> {
    samplesList = payload
})

export function getSamples() { return samplesList }

// end of sample util functions

export function selectDropDownItemForUpdate(elementId, item, itemDataList) {
        // set dropdownItem to the selected item
        let element = document.getElementById(elementId);

        // look up the datalist for a similar name as the value the holder has;
        for (let i = 0; i < itemDataList.length; i++) {
            if (item === itemDataList[i].Name || item === itemDataList[i].Code) {
                // -> assign the code to the itemCode
                item = itemDataList[i].Code

                // -> Update the dropdown element value to have the itemName
                element.value = itemDataList[i].Name
                return item
        }
    }
}

// DATE FUNCTIONS
export function isRetentionPeriodValid(dbDate) {
    return Date.parse(dbDate) >= Date.now();
}

export function overDueRetentionPeriod(dbDate) {
    let timeDiff = Math.abs(Date.parse(dbDate) - Date.now())
    let oneDay = 1000 * 60 * 60 * 24; //milliseconds

    let totalDays = timeDiff / oneDay; // take out milliseconds and convert to days
    let years = Math.floor(totalDays / 365)
    let months = Math.floor(totalDays % 365 / 30)
    let days = Math.floor(totalDays % 365 % 30)

    let yearsDisplay = years > 0 ? years + (years === 1 ? " year " : " years ") : "";
    let monthsDisplay = months > 0 ? months + (months === 1 ? " month " : " months ") : "";
    let daysDisplay = days > 0 ? days + (days === 1 ? " day" : " days") : "";
    return yearsDisplay + monthsDisplay + daysDisplay;
}

export function getThisYear() {
    return (new Date().getFullYear()).toString()
}


/** continuation of sample functions -- This Vuex store will be used for temporarily saving sample details from the
 * Add Sample form wizard.
 *  - The save will happen once the user hits __Save Draft__ button.
 *  - On update of the form, the state will be retrieved and displayed to the user, if more changes occur, then a
 *  comparison of the content of the previous state and the current state will be done.
 *  - Deletion will occur when the form is submitted. */

const newSampleStore = new Vuex.Store({
    state: {
        sample: {
            //tabOneData
            theme: null, species: null, project: null, sampleOwner: null,
            sampleType: null, description: null, projectHead: null,

            //tabTwoData
            locationCollected: null, date_of_collection: null, slots: null,
            temperature: null, amount: null, quantity_type: null,

            // tabThreeData
            bioHazardLevel: null, analysis: null, retention: null, convertedRetentionPeriod: null, sampleLocation: null,
        }
    },
    plugins: [
        createPersistedState({
            storage: {
                getItem: key => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: key => ls.remove(key)
            }
        })
    ],
    mutations: {
        sampleInfo: (state, payload) => {
            return payload ?
                (
                    state.sample = {
                        // tabOneData
                        theme: payload.theme, species: payload.species, project: payload.project,
                        sampleOwner: payload.sampleOwner, sampleType: payload.sampleType,
                        description: payload.description, projectHead: payload.projectHead,

                        // tabTwoData
                        locationCollected: payload.locationCollected, date_of_collection: payload.date_of_collection,
                        slots: payload.slots, temperature: payload.temperature, amount: payload.amount, quantity_type: payload.quantity_type,

                        // tabThreeData
                        bioHazardLevel: payload.bioHazardLevel, analysis: payload.analysis,
                        retention: payload.retention, convertedRetentionPeriod: payload.convertedRetentionPeriod,

                        // sample location
                        sampleLocation: payload.sampleLocation
                    }
                )
                :
                (
                    state.sample = {}
                )
        },
    }
});

export function secureStoreSetSampleInfo(tabOneData, tabTwoData, tabThreeData, sampleLocation){
    newSampleStore.commit('sampleInfo', {
        // tabOneData
        theme: tabOneData.sample.theme, species: tabOneData.sample.species, project: tabOneData.sample.project,
        projectHead: tabOneData.sample.projectHead, sampleOwner: tabOneData.sample.sampleOwner,
        sampleType: tabOneData.sample.sampleType, description: tabOneData.sample.description,

        // tabTwoData
        locationCollected: tabTwoData.sample.locationCollected, slots: tabTwoData.sample.slots,
        date_of_collection: tabTwoData.sample.date_of_collection, temperature: tabTwoData.sample.temperature,
        amount: tabTwoData.sample.amount, quantity_type: tabTwoData.sample.quantity_type,

        // tabThreeData
        bioHazardLevel: tabThreeData.sample.bioHazardLevel, analysis: tabThreeData.sample.analysis,
        retention: tabThreeData.sample.retention, convertedRetentionPeriod: tabThreeData.sample.convertedRetentionPeriod,

        // sample-location
        sampleLocation: sampleLocation

    })
    return getStoredSampleDetails()
}

export function getStoredSampleDetails(){ return newSampleStore.state.sample }

export function secureStoreDeleteSampleInfo() {
    newSampleStore.commit('sampleInfo', null);
}

// loader function
export function startLoader(self) {
    return self.$loading.show({
        isFullPage: true,
        canCancel: false,
        color: '#074880',
        loader: 'dots',
        width: 255,
        height: 255,
        backgroundColor: '#FAAB2C',
        opacity: 0.7,
        zIndex: 999,
    })
}

// loader function for get
export function pageStartLoader(self, loader='spinner') {
    return self.$loading.show({
        isFullPage: true,
        canCancel: false,
        color: '#074880',
        loader: loader,
        width: 128,
        height: 128,
        backgroundColor: '#FAAB2C',
        opacity: 0.7,
        zIndex: 999,
    })
}


// PAGINATION FUNCTIONS
let page_info = {};
let page_array = [];

export function paginate(data) {
    let start, end;

    start = page_info.pageSize * (page_info.pageNumber - 1)
    end = start + page_info.pageSize

    page_array.splice(0, page_array.length);

    if (end > data.length) end = data.length;
    for (let i = start; i < end; i++) {
        page_array.push(data[i])
    }

    return {'arr': page_array, 'pg_len': data.length}
}

EventBus.$on('page-info', (payload) => {
    page_info = payload.pgInfo
    paginate(payload.pgData)
})


// generic function to handle errors on web-server response
export function handleError(self, error, loader){
    self.$log.error(error);
    loader.hide();

    if (error.response){
        if (error.response.status === 304) {
            showFlashMessage(self, 'info', 'Record not modified!', '');
        } else if (error.response.status === 400) {
            showFlashMessage(self, 'error', error.response.data['message'], 'Kindly refill the form');
        } else if (error.response.status === 401) {
            respondTo401(self);
        } else if (error.response.status === 403) {
            showFlashMessage(self, 'error', 'Unauthorized', error.response.data['message'])
            EventBus.$emit('unauthorized-access', error.response.data['message'])
        } else if (error.response.status === 404) {
            showFlashMessage(self, 'error', 'Not found', error.response.data['message']);
        } else if (error.response.status === 406) {
            redirectAfterCountDown(self, '/requestConfirmation')
            return error.response.data.message
        } else if (error.response.status === 408) {
            redirectAfterCountDown(self, '/forgot')
            return error.response.data.message
        } else if (error.response.status === 409) {
            showFlashMessage(self, 'error', error.response.data['message'], '');
        } else if (error.response.status === 422) {
            showFlashMessage(self, 'error', error.response.data['message'], 'Unable to process request');
        } else if (error.response.status === 500) {
            showFlashMessage(self, 'error', "Fatal Error", 'Admin has been contacted.');
        } else {
            showFlashMessage(self, 'error', error.response.data['message'], '');
        }
    }
}

// cart functions
let cartItems = []

export function addToCart(sampleCode){
  if (!cartItems.includes(sampleCode)){
    cartItems.push(sampleCode)
  } else if (cartItems.includes(sampleCode)){
    // remove item from cart
    for( let i = 0; i < cartItems.length; i++){
      if ( cartItems[i] === sampleCode) {
          cartItems.splice(i, 1);
      }
    }
  }
  EventBus.$emit('add-to-cart', cartItems)
}

/* listens to the batch sample request completion event and resets the cartItems list with the
 passed payload which is an empty list */
EventBus.$on('batch-request-complete', payload => {
  cartItems = payload
})

export function getCartItems(){ return cartItems; }



// FreezerView Functions
let freezerCode = ""

EventBus.$on('freezerSet', freezer=>{
  freezerCode = freezer
})

export function getFreezerCode(){
    return freezerCode
}


// differentiates the kind of box layout to be shown
let is_creating = false

EventBus.$on('sample-creating', data => {
    is_creating = data
})

EventBus.$on('samples-created', data => {
    is_creating = data
})

export function getIsCreating(){
    return is_creating
}


export function returnUniquesInArray(arr){
    /**
   * The function checks that no sample in slot shares data with another sample. ***/
  Array.prototype.contains = function(v) {
    for (let i = 0; i < this.length; i++) {
      if (this[i] === v) return true;
    }
    return false;
  };

  Array.prototype.unique = function() {
    let arr = [];
    for (let i = 0; i < this.length; i++) {
      if (!arr.contains(this[i])) {
        arr.push(this[i]);
      }
    }
    return arr;
  }

  return arr.unique()
}


/** Functions to check editable div contents */
// Called on focus-out event to set the new value if changed otherwise dynamically raise error
export function getNewDivData(index){
    // use the trim method to remove leading and trailing white spaces
    let cellValue = parseInt(this.$refs.cells[index].textContent.trim())
    newDivData(index, cellValue)
}

export function getNewDivDataForTableForm(index){
    // use the trim method to remove leading and trailing white spaces
    let cellValue = parseInt(this.$refs.cells.textContent.trim())
    newDivData(index, cellValue)
}

function newDivData(index, cellValue){
    if (cellValue !== 0 && !isNaN(cellValue)){
        EventBus.$emit('new-div-data', {'cellValue': cellValue, 'index': index})
    } else {
        document.getElementById('input_'+index).textContent = 'error!!!';
        document.getElementById('input_'+index).style.backgroundColor = 'red';
    }
}

    // Called on focus-in to reset the <div> to preferred state i.e bgColor and textContent
export function clearDivError(index){
    document.getElementById('input_'+index).textContent = "0";
    document.getElementById('input_'+index).style.backgroundColor = 'white';
}


/** setters and getters for user-dashboard info*/
let response = {}

export function setUserDashboardInfo(info){
    response = info
}

export function getUserDashboardInfo(){
    return response
}


// function to prepare for a batch sample request response
export function validateResponse(batchSampleRequests){
    let batchSamplesResponse = []
    for (let i=0; i < batchSampleRequests.length; i++){

        // set the enabled flag as Strings recognised in the backend service
        if (batchSampleRequests[i].enabled === true){
          batchSampleRequests[i].enabled = APPROVED_STATUS
        } else {
          batchSampleRequests[i].enabled = DECLINED_STATUS
        }

        if ('id' in batchSampleRequests[i]){
            if (batchSampleRequests[i].enabled === APPROVED_STATUS && batchSampleRequests[i].approved_amount === '0'){
                // the requested amount has been approved as is
                batchSampleRequests[i].approved_amount = parseInt(batchSampleRequests[i].amount)
            }

            let sampleRequestResponse = {
              'id': batchSampleRequests[i].id,
              'code': batchSampleRequests[i]['requested_sample.code'],
              'status': batchSampleRequests[i].enabled,
              'approved_amount': batchSampleRequests[i].approved_amount,
            }
            batchSamplesResponse.push(sampleRequestResponse)
        } else {
            if (batchSampleRequests[i].enabled === APPROVED_STATUS && batchSampleRequests[i].approved === 0){
                // the requested amount has been approved as is
                batchSampleRequests[i].approved = parseInt(batchSampleRequests[i].amount)
            }

            let sampleRequestResponse = {
              'id': batchSampleRequests[i].code,
              'code': batchSampleRequests[i].sample_code,
              'status': batchSampleRequests[i].enabled,
              'approved_amount': batchSampleRequests[i].approved,
            }
            batchSamplesResponse.push(sampleRequestResponse)
        }
  }
  return batchSamplesResponse
}

export function respondToBatchRequest(sampleList, self, notes=null, responsePath=null){
    let batchSamplesResponse = validateResponse(sampleList)

    if (responsePath === null){
        responsePath = researcher_resource
    }
    if (notes === null){notes=""}

    let loader = startLoader(self)
      axios.put(responsePath, {'response': {
          response: batchSamplesResponse,
          notes: notes
        }}, {
        headers: {
          Authorization: secureStoreGetAuthString()
        }
      })
        .then((response) => {
          setTimeout(() => {
            loader.hide()
            if (response.status === 200) {
              showFlashMessage(self, 'success', response.data['message'], '')
              redirectAfterCountDown(self, '/home')
            }
          }, 1000)
        })
        .catch((error) => {
          handleError(self, error, loader)
        })
}


// selectors
let projectHeadName = null
let projectHeadEmail = null

// todo: ideal function
export function setProjectHead(projectList, selectorDataList) {
    /**
    * function takes 2 sets of data-lists;
     * :projectList - initial list from server
     * :selectorDataList - formatted list with code and name for the dropdown selector
     * It then checks for a relationship and returns the email and full name of the project head*/

    let item = getSelectedItemCode("project-dropdownlist", selectorDataList)

    // fill details about the project head and sample owner/PI as well
    for (let i = 0; i < projectList.length; i++) {
        if (item === projectList[i].code) {
          projectHeadEmail = projectList[i]['lead.email']
          projectHeadName = projectList[i]['lead.first_name'] + " " + projectList[i]['lead.last_name']
        }
    }
    EventBus.$emit('set-project-head-details', {
        'project': item,
        'email': projectHeadEmail,
        'name': projectHeadName,
    })
}

// todo: ideal way to fetch data
export function getProjectDataList(){
  // GET PROJECT LIST
  getItemDataList(project_resource).then(data => {
    // save this data for re-use
    let projectList = extractApiData(data);
    EventBus.$emit('get-project-data-list', {
      'projectList': data,
      'selectorList': projectList
    })
  })
}

export function getThemeDataList(){
    // GET THEME LIST
    getItemDataList(theme_resource).then(data => {
        let themeList = extractApiData(data);

        EventBus.$emit('get-theme-data-list', {
            'themeList': data,
            'selectorList': themeList
        })
    })
}

export function getQuantityTypeDataList(){
    // GET QUANTITY TYPE LIST
    getItemDataList(quantity_type_resource).then(data => {
        let QTList = extractQTData(data);
        EventBus.$emit('get-QT-data-list', QTList)
    })
}

export function getSampleTypeDataList(){
    getItemDataList(sample_type_resource).then(data => {
        let sampleTypeList = extractApiData(data);
        EventBus.$emit('get-sampleType-data-list', sampleTypeList)
    })
}

export function getBioHazardLevelDataList(){
    // GET SECURITY LEVEL LIST
    getItemDataList(bio_hazard_level_resource).then(data => {
        let bioHazardLevelList = extractApiData(data);
        EventBus.$emit('get-bio-hazard-level-data-list', bioHazardLevelList)
    })
}

// todo: ideal way to fetch data
export function getLocationCollected(){
      // GET StudyBlock LIST
    getItemDataList(study_block_resource).then(data => {
        let locationList = extractApiData(data);
        EventBus.$emit('get-location-data-list', locationList)
    })
}

export function getUserDataList(){
    // GET User List;
    // In the parameters list pass true as a param so that the web-server uses is_active field as the query string
    getItemDataList(user_resource, {q: true}).then(data => {
        let userList = extractUserData(data)
        EventBus.$emit('get-user-data-list', userList)
    })
}

export function getUserRoles(){
    getItemDataList(role_resource).then(data => {
        let roleList = extractApiData(data)
        EventBus.$emit('get-user-roles', roleList)
    })
}

/** This function sets the drop down list item value. It takes two arguments;
 * - name of the drop-down-list
 * - the drop down data list
 * and returns the item code for the drop-down.*/
export function setDropDownItemValue(drop_down_name, drop_down_data_list){
    return getSelectedItemCode(drop_down_name, drop_down_data_list)
}

/** sort_by constant that takes a field to sort and applies the sort mechanism by given field.*/

export const sort_by = (field, reverse, primer) => {

    const key = primer ?
    function(x) {
      return primer(x[field])
    } :
    function(x) {
      return x[field]
    };

    reverse = !reverse ? 1 : -1;

    return function(a, b) {
    return a = key(a), b = key(b), reverse * ((a > b) - (b > a));
    }
}

/** To restore saved data for box slots, the sample location data needs to be saved and retrieved efficiently as there
 * are several components included. The functions below shall set and get this data as required.*/

let sample_location_details = {}

EventBus.$on('sample_location_details', payload=> {
    if (Object.keys(sample_location_details).length === 0){
        sample_location_details = payload
    }else{
        /*object spread operator {...} -- It copies own enumerable properties from a provided object onto a new object.
        * Therefore allowing for 'appending' to the dictionary by Shallow-cloning as contrasted to Object.assign().*/
        sample_location_details = {...sample_location_details, ...payload}
    }
})

export  function getSampleLocationDetails(){
    return sample_location_details
}

export function deleteSampleLocationDetails(){
    sample_location_details = {}
}

// retrieving sample storage location details.
let sample_storage_loc_details = {}

EventBus.$on('retrieve_sample_location_details', payload=> { sample_storage_loc_details = payload })

export function getSampleStorageLocationDetails(){
    return sample_storage_loc_details
}

export function deleteSampleStorageLocationDetails(){
    sample_storage_loc_details = {}
}